export const GET_TICKETS = 'GET_TICKETS';
export const ERROR_TICKETS = 'ERROR_TICKETS';
export const CLEAR_TICKETS = 'CLEAR_TICKETS';
export const GET_TICKET_BY_ID = 'GET_TICKET_BY_ID';
export const ERROR_TICKET_BY_ID = 'ERROR_TICKET_BY_ID';
export const CLEAR_TICKET_BY_ID = 'CLEAR_TICKET_BY_ID';
export const CREATE_TICKET = 'CREATE_TICKET';